/**
 * Query stale time in milliseconds
 * Data is considered fresh for this duration before automatic refetch
 */
export const QUERY_STALE_TIME_MS = 30 * 1000; // 30 seconds

/**
 * Cache invalidation delay in milliseconds
 * Used after mutations that require eventual consistency
 */
export const CACHE_INVALIDATION_DELAY_MS = 2000; // 2 seconds
